<script>

</script>

<template>

  <div class="col-md-auto box">

    <div class="row" style="padding-top: 50px;">
      <h1 class="col flex-grow-1 heading">Reporting</h1>
    </div>

    <hr>

    <div id="controls" class="d-flex-column">

      <div id="orders" class="d-flex">
        <div class="group">
          <p>Objednávky</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="check1" checked>
          <label for="rad-all">Všechny</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="check1">
          <label for="rad-paid">Zaplacené</label>
        </div>
      </div>

      <div id="currency" class="d-flex">
        <div class="group">
          <p>Měna</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="check1" checked>
          <label for="rad-czk">Kč</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="check1">
          <label for="rad-eur">Eur</label>
        </div>
      </div>

      <div id="e-shops" class="d-flex-column">

        <div id="e-shops1" class="d-flex">
          <div class="group">
            <p>E-shopy</p>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-all" checked>
            <label for="check-all">Všechny</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-oj-cz">
            <label for="check-oj-cz">OJ-CZ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-cz">
            <label for="check-el-cz">EL-CZ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-sk">
            <label for="check-el-sk">EL-SK</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-es">
            <label for="check-el-es">EL-ES</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-el-pl">
            <label for="check-el-pl">EL-PL</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-test">
            <label for="check-test">Testy</label>
          </div>
        </div>

        <div id="e-shops2" class="d-flex">
          <div class="group">
            <p> </p>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-iph-el">
            <label for="check-iph-el">iPhone-EL</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-iph-oj">
            <label for="check-iph-oj">iPhone-OJ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-and-el">
            <label for="check-and-el">Android-EL</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-and-oj">
            <label for="check-and-oj">Android-OJ</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-kk">
            <label for="check-kk">KKlub</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-google">
            <label for="check-google">Google</label>
          </div>
          <div class="d-flex check-mate">
            <input type="checkbox" id="check-fb">
            <label for="check-fb">Facebook</label>
          </div>
        </div>

      </div>

      <div id="content" class="d-flex-column">

        <div id="content1" class="d-flex">
          <div class="group">
            <p>Zobrazení</p>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-sales" checked>
            <label for="rad-sales">Tržby</label>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-count">
            <label for="rad-count">Kusy</label>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-trial">
            <label for="rad-trial">Trial</label>
          </div>
          <div class="d-flex check-mate-end">
            <input type="checkbox" id="check-delta" checked>
            <label for="check-delta">Změna</label>
          </div>
        </div>

        <div id="content2" class="d-flex">
          <div class="group">
            <p> </p>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-tests">
            <label for="rad-tests">Otestovaní</label>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-regs">
            <label for="rad-regs">Registrace</label>
          </div>
          <div class="d-flex check-mate">
            <input type="radio" id="rad-app">
            <label for="rad-app">Stažení apky</label>
          </div>
        </div>

      </div>

      <div id="period" class="d-flex">
        <div class="group">
          <p>Období</p>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-year" checked>
          <label for="rad-year">Roční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-half">
          <label for="rad-half">Půlroční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-quarter">
          <label for="rad-quarter">Čtvrtletní</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-month">
          <label for="rad-month">Měsíční</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-week">
          <label for="rad-week">Týdenní</label>
        </div>
        <div class="d-flex check-mate">
          <input type="radio" id="rad-day">
          <label for="rad-day">Denní</label>
        </div>
      </div>

      <div id="buttons" class="d-flex">

        <div class="group">
          <p> </p>
        </div>

        <div id="show-button">
          <button id="show">Zobrazit</button>
        </div>

        <div class="f-button">
          <button id="show">Uložit filtr</button>
        </div>

        <div class="f-button">
          <button id="show">Načíst filtr</button>
        </div>

      </div>

    </div>

    <hr>

  </div>

</template>

<style scoped>

.check-mate {
  margin-right: 25px;
  width: 120px;
}

.check-mate-end {
  margin-right: 25px;
  width: 180px;
}

.check-mate input {
  margin-right: 5px;
}

.check-mate-end input {
  margin-right: 5px;
}

.check-mate label {
  margin-top: 7px;
  font-size: 18px;
}

.check-mate-end label {
  margin-top: 7px;
  font-size: 18px;
}

.group {
  width: 130px;
}

.group p {
  margin: 0;
  margin-top: 7px;
  margin-right: 25px;
  font-size: 18px;
  font-weight: bolder;
}

#orders {
  margin-right: 50px;
}

#buttons {
  margin-top: 10px;
  margin-bottom: 25px;
}

button {
  background-color: #37A8D6;
  color: white;
  //font-size: 1rem;
  border-radius: 5px;
  border: none;
  padding: 7px 20px 7px 20px;
  text-transform: uppercase;
  font-weight: bold;
}

#show-button {
  margin-right: 180px;
}

.f-button {
  margin-right: 20px;
}

</style>